import { Injectable } from '@angular/core';
import Pusher, { Channel } from 'pusher-js';

@Injectable({
  providedIn: 'root',
})
export class PusherService {
  pusher: Pusher;

  constructor() {
    // this.pusher = new Pusher('1d8af0053f0ef37acfca', {cluster: 'ap2'});
  }

  subscribe(channelName: string, eventName: string, callback: Function): void {
    const channel: Channel = this.pusher.subscribe(channelName);
    channel.bind(eventName, callback);
  }
}
